import React, { PureComponent } from 'react'
import styled from 'styled-components'
import moment from 'moment'

const DateTime = styled.div`
  color: #848e9c;
  font-size: 12px;
  height: 18px;
  line-height: 18px;
  font-family: 'DINNext';
  @media (max-width: 768px) {
    display: none;
  }
`

class IntervalDate extends PureComponent {
  state = {
    datetime: moment(new Date()).format('YYYY-MM-DD HH:mm:ss'),
  }

  componentDidMount() {
    this.intervalHandler = setInterval(() => {
      this.setState({ datetime: moment(new Date()).format('YYYY-MM-DD HH:mm:ss') })
    }, 1000)
  }

  componentWillUnmount() {
    clearInterval(this.intervalHandler)
  }

  render() {
    const { datetime } = this.state
    return <DateTime>{datetime}</DateTime>
  }
}

export default IntervalDate
